module.exports = __webpack_public_path__ + "static/media/mikmak-logo.fc3efef9.png";


//////////////////
// WEBPACK FOOTER
// ./client/assets/mikmak-logo.png
// module id = 377
// module chunks = 0